import { useAuthorize } from 'app/hooks/use-authorize';
import { useUser } from 'app/network/user';
import { canUseOfferHub } from 'app/screens/intro/navigator-helper';
import type { NewScreenParams } from 'app/screens/new';
import { ListingType } from 'app/types/listing';
import type { ScreenParameters, SpecificNavigationProp } from 'app/types/navigation';

/** Start an offer; form continuations and explicit manual choices must keep using /new. */
export function useOpenOffer() {
  const { data: user, isPending } = useUser();
  const authorize = useAuthorize('publish');

  return <T extends keyof ScreenParameters>(navigation: SpecificNavigationProp<T>, params: NewScreenParams = {}) => {
    const screenParams = { ...params, defaultValues: { ...params.defaultValues, type: ListingType.offer } };
    authorize(() => {
      if (canUseOfferHub(user?.featureFlags, isPending)) {
        navigation.navigate('offer-hub', screenParams);
      } else {
        navigation.navigate('new', screenParams, { pop: true });
      }
    });
  };
}
